import { createI18n } from 'vue-i18n'

// Translation messages
const messages = {
  en: {
    welcome: "Welcome to our application!",
    head_title:"Live AI Assistant Website",
    intro: {
      service_features:"Features",
      service_features_text:"Live AI, a website that lets you practice your conversation skills, integrates the most advanced AI language processing technology. It uses intelligent algorithms to provide different conversation topics every month, allowing students to use their spare time to practice speaking in English and improve their conversation skills.",
      remark:"Note",
      remark_text:"When using this website, please make sure that the information you enter is correct and complete. This will help the AI assistant generate content that best suits your needs. Also remember to carefully check output from the AI to ensure that it meets your expectations.",
      remark_text2:"The website provides real-time interactive feedback through generative AI. If the AI’s response does not meet your expectations, please try changing your input to generate a new response.",
      disclaimer:"免責聲明",
      disclaimer_text:"本網站在AI小幫手所提供的AI生成式內容，部分功能由Microsoft 與OPEN AI技術支援。本公司對於因使用生成式AI 提供的生成內容以及服務可能產生的任何直接或間接損害不承擔責任。詳情請看 <a class='underline text-blue-500' href='https://store.liveabc.com/company/AI' target='_blank'>免責聲明</a>。",
      Instructions_for_use:"Instructions",
      step1_title:"Choose topic",
      step1_text:"Choose a topic you want to have a conversation about.",
      step2_title:"Input data",
      step2_text:"Respond to the prompt by typing your answer in the designated field, or using voice input. Click submit and wait for the AI assistant to interact with you.",
      step3_title:"Check result",
      step3_text:"After the AI assistant responds, read the generated content and answer appropriately.",
      step4_title:"More function",
      step4_text:"During the conversation you can access other functions including dictionary lookup, Chinese translation, full-passage narration, and explanation of generated content, among other extended functions to further your learning. "
    },
    life:{
      speaking_practice_assistant:"AI Conversation Assistant",
      restart:"Reset",
      selectedAns:"You have chosen:"
    },
    hover:{
      ai_reply:"AI answering",
      record:"Start/Stop recording",
      play:"Play back the sentence",
      translate:"Chinese translation",
      my_voice:"Play",
      more_instructions:"More explanations",
      refresh:"Refresh",
      sent:"Submit",
      placeholder:"Click on the 「Microphone」 icon to record your response, or click on 「AI」to generate response suggestions."
    }
  },
  zh: {
    welcome: "Welcome to our application!",
    head_title: "AI口說小助教",
    intro: {
      service_features:"服務特色",
      service_features_text:"AI口說小助教整合最先進 AI 語言處理技術，透過智能化演算法，每月提供不同對話主題，讓學生利用零碎時間自由練習英語會話，提升英語口說會話實力。",
      remark:"備註",
      remark_text:"使用時，請確保您輸入的資訊正確完整，這有助於 AI 小幫手生成最適合您需求的內容。同時，請記得審慎確認最終產出的文件，以確保符合您的期望和準確性。",
      remark_text2:"本區透過生成式 AI 即時互動回饋，若 AI 回應不符合您的預期，請嘗試重新生成，以參考您需要的內容。",
      disclaimer:"免責聲明",
      disclaimer_text:"本網站在AI小幫手所提供的AI生成式內容，部分功能由Microsoft 與OPEN AI技術支援。本公司對於因使用生成式AI 提供的生成內容以及服務可能產生的任何直接或間接損害不承擔責任。詳情請看 <a class='underline text-blue-500' href='https://store.liveabc.com/company/AI' target='_blank'>免責聲明</a>。",
      Instructions_for_use:"使用說明",
      step1_title:"選擇類型",
      step1_text:"請點選您想要練習對話的情境主題",
      step2_title:"輸入資料",
      step2_text:"在指定欄位中以鍵盤輸入或直接口說回答問題，點擊送出後，請稍作等待，由 AI 小助教和您互動對話",
      step3_title:"查看成果",
      step3_text:"等待AI 小助教回應後，請再次閱讀所生成內容並做下一句回答。",
      step4_title:"更多功能",
      step4_text:"歡迎點擊字典查詢、中文翻譯、全文播放、AI 代答、更多說明等延伸功能進行進一步學習。若想獲得更多靈感，請嘗試重新生成，或選擇不同情境，進行更多互動練習。"
    },
    life:{
      speaking_practice_assistant:"口說練習小幫手",
      restart:"重新開始",
      selectedAns:"你已選擇："
    },
    hover:{
      ai_reply:"AI代答",
      record:"開始/停止錄音",
      play:"播放原音",
      translate:"中文翻譯",
      my_voice:"播放錄音",
      more_instructions:"更多說明",
      refresh:"重新整理",
      sent:"送出",
      placeholder:"請點「麥克風」開始錄音應答，或點「AI」生成回應建議。"
    }
  }
};

const i18n = createI18n({
  locale: 'zh',
  fallbackLocale: 'zh',
  messages
})

export default i18n;